import { toast, ToastAction } from '@valwin/facto/components';
import { ChevronRightIcon } from '@valwin/facto/icons';

import { NotificationStatus } from './types';

type DisplayStatusParams = {
  status: NotificationStatus;
  description: string;
  actionLabel: string;
  onClick: () => void;
};

export const displayToast = ({
  status,
  description,
  actionLabel,
  onClick,
}: DisplayStatusParams) => {
  const toastConfig = {
    description,
    action: (
      <ToastAction onClick={onClick}>
        {actionLabel} <ChevronRightIcon />
      </ToastAction>
    ),
  };

  if (status === 'success') {
    toast.info('Information', toastConfig);
  } else {
    toast.error('Erreur', toastConfig);
  }
};
